/**
 *
 * @param frameId
 * @param params
 *
 * params = {
 * titulo: 'Titulo da pagina',
 * ...params
 * }
 */

const origin = 'omnichannel'
const formatInboxBadge = (count) => (count > 99 ? '99+' : count)

export const emmitTrocarPagina = (frameId, params) => {
  let data = {
    origin,
    client: frameId,
    type: 'command',
    command: 'TROCA_PAGINA',
    data: {
      titulo: params.titulo,
      ...params
    },
    timestamp: Date.now()
  }

  window.parent.postMessage(data, '*')
}

export const emitNewPrescription = (frameId, data) => {
  const payload = {
    uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
    origin,
    client: frameId,
    type: 'command',
    command: 'NOVA_PRESCRICAO',
    data,
    timestamp: Date.now()
  }

  window.parent.postMessage(payload, '*')
}

export const emitInboxCount = (frameId, count) => {
  const badge = formatInboxBadge(count)

  const payload = {
    uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
    origin,
    client: frameId,
    type: 'command',
    command: 'INBOX_COUNT',
    data: {
      count,
      unread: count,
      badge
    },
    timestamp: Date.now()
  }

  window.parent.postMessage(payload, '*')
}

export const emitInboxClear = (frameId) => {
  const badge = formatInboxBadge(0)

  const payload = {
    uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
    origin,
    client: frameId,
    type: 'command',
    command: 'INBOX_CLEAR',
    data: {
      count: 0,
      unread: 0,
      badge
    },
    timestamp: Date.now()
  }

  window.parent.postMessage(payload, '*')
}
